export enum SagentModel {
  OPUS_4_8 = 'opus-4.8',
  GEMINI_3_7_FLASH = 'gemini-3.7-flash',
  GEMINI_3_8_FLASH = 'gemini-3.8-flash',
  GROK_4_6 = 'grok-4.6',
  GPT_5_6_SOL = 'gpt-5.6-sol',
  GPT_6_ASTRA = 'gpt-6-astra',
}

export const DEFAULT_SAGENT_MODEL = SagentModel.GEMINI_3_8_FLASH

export function isSagentModel(value: unknown): value is SagentModel {
  return (
    typeof value === 'string' &&
    Object.values(SagentModel).includes(value as SagentModel)
  )
}
